import bgWaveWhite from "./bgWaveWhite.svg"
import bgWaveYellow from "./bgWaveYellow.svg"
import bgWavePurpule from "./bgWavePurple.svg"
import bgWavePink from "./bgWavePink.svg"
import bgWaveLightgreen from "./bgWaveLightGreen.svg"
import shatter from "./shatter.svg"
import roof from "./Roof 1.svg"

import line1 from "./Line 1.svg"
import line2 from "./Line 2.svg"
import line3 from "./Line 3.svg"
import line4 from "./Line 4.svg"

import mediaLine1 from "./mediaLine 1.svg"
import mediaLine2 from "./mediaLine 2.svg"
import mediaLine3 from "./mediaLine 3.svg"
import mediaLine4 from "./mediaLine 4.svg"

import bannerText from "./bannertext.png"
import sourLmli from "./sourLmli.png"
import sourFruit from "./sourfruit.png"
import mangoBox from "./mangobox.png"
import mangoKid from "./mangokid.png"
import lollipop from "./lollipop.png"
import jamun from "./jamun.png"
import mixfruits1 from "./mixfruit1.png"
import mixfruits2 from "./mixfruit2.png"
import candies1 from "./candies.png"
import candies2 from "./candies2.png"

import mediaBgWhite from "./mediaBgWhite.svg"
import mediaBgYellow from "./mediaBgYellow.svg"
import mediaBgPurple from "./mediaBgPurple.svg"
import mediaBgPink from "./mediaBgPink.svg"
import mediaBgGreen from "./mediaBgGreen.svg"
import mediaShatter from "./mediaShatter.png"


export const assets = {
	bgWaveWhite,
	bgWaveYellow,
	bgWavePurpule,
	bgWavePink,
	bgWaveLightgreen,
	shatter,
	roof,

	line1,
	line2,
	line3,
	line4,

	bannerText,
	sourLmli,
	sourFruit,
	mangoBox,
	mangoKid,
	lollipop,
	jamun,
	mixfruits1,
	mixfruits2,
	candies1,
	candies2,

	mediaBgWhite,
	mediaBgYellow,
	mediaBgPurple,
	mediaBgPink,
	mediaBgGreen,
	mediaShatter,

	mediaLine1,
	mediaLine2,
	mediaLine3,
	mediaLine4,
}
